<script>
import EventTimeZoneChooser from './event-time-zone-chooser.vue'

export default {
  name: 'LayoutClock',
  props: {
    timzeone: {
      type: String,
    },
  },
  data() {
    return {
      time: null,
      interval: null,
    }
  },
  beforeUnmount() {
    clearInterval(this.interval)
  },
  created() {
    this.time = new Date()
    this.interval = setInterval(() => {
      this.time = new Date()
    }, 1000)
  },
  components: {
    EventTimeZoneChooser,
  },
}
</script>
<template lang="pug">
.layout-clock
  event-time-zone-chooser.x-small(v-slot="{ timeZone, isOpen }")
    .dropdown-trigger-layout(:class="{ 'is-open': isOpen }")
      .d-grid.justify-items-start.gap-1
        time-display(:time="time" :timezone="$store.state.session.timeZone")
        .color-outline {{ timeZone }}
      .icon.mi-outlined.mi-keyboard-arrow-down
</template>

<style scoped lang="scss">
@use 'sass:map';
@use 'frontend_stylesheets/theme-variables' as themeVariables;

.dropdown-trigger-layout {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0 8px 0 12px;
  height: 48px;
  border-radius: themeVariables.$borderRadius;

  &.is-open {
    background: map.get(themeVariables.$colors, containerHighest);
  }
  &:hover {
    background: map.get(themeVariables.$colors, containerHighest);
  }
}
//.items {
//  display: flex;
//  justify-content: center;
//  align-items: center;
//  flex-direction: column;
//}
</style>
